export default class extends Controller {
  static targets = ["editField"];

  submitWithEdit() {
    this.editFieldTarget.value = "1";
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/new-event-form-controller.js